import React, { useState, useEffect, useRef, useCallback } from "react";
import "../Portfolio/Portfolio.css";
import portfolioastronaut from '../../assets/images/Astro_Stand_Hologram.gif';
import astronautwalking from '../../assets/images/astronaut-walking.gif';
import astronautlaptop from '../../assets/images/astronaut-laptop7.gif';
import rocket from '../../assets/images/rocket_launches_2.gif';
import client1 from '../../assets/images/client1.webp'
import client2 from '../../assets/images/client2.webp'
import client3 from '../../assets/images/client3.webp'
import client4 from '../../assets/images/client4.webp'
import client5 from '../../assets/images/client5.webp'
import client6 from '../../assets/images/client6.webp'
import client7 from '../../assets/images/client7.webp'
import client8 from '../../assets/images/client8.webp'
import client9 from '../../assets/images/client9.webp'
import client10 from '../../assets/images/client010.webp'
import client11 from '../../assets/images/client11.webp'
import client12 from '../../assets/images/client12.webp'
import client13 from '../../assets/images/client13.webp'
import client14 from '../../assets/images/client14.webp'
import client15 from '../../assets/images/client15.webp'
import client16 from '../../assets/images/client16.webp'
import client17 from '../../assets/images/client17.webp'
import client18 from '../../assets/images/client18.webp'
import client19 from '../../assets/images/client20.webp'
import client20 from '../../assets/images/client21.webp'
import client21 from '../../assets/images/client22.webp'
import website1 from '../../assets/images/portfolio-website1.webp'
import website2 from '../../assets/images/portfolio-website2.webp'
import website3 from '../../assets/images/portfolio-website3-1.png'
import website4 from '../../assets/images/portfolio-website4.webp'
import website5 from '../../assets/images/portfolio-website5.webp'
import website6 from '../../assets/images/portfolio-website6.png'
import website7 from '../../assets/images/portfolio-website7.png'
import website8 from '../../assets/images/portfolio-website8.png'
import website9 from '../../assets/images/portfolio-website9.png'
import website10 from '../../assets/images/portfolio-website10.png'
import website11 from '../../assets/images/portfolio-website11.png'
import website12 from '../../assets/images/portfolio-website12.png'
import website13 from '../../assets/images/portfolio-website13.png'
import website14 from '../../assets/images/portfolio-website14.png'
import website15 from '../../assets/images/portfolio-website15.png'
import website16 from '../../assets/images/portfolio-website16.png'




import mobile1 from '../../assets/images/portfolio-mobile1.png'
import mobile2 from '../../assets/images/portfolio-mobile2.webp'
import mobile3 from '../../assets/images/portfolio-mobile3-1.png'
import mobile4 from '../../assets/images/portfolio-mobile4-1.png'
import mobile5 from '../../assets/images/portfolio-mobile5.webp'
import mobile6 from '../../assets/images/portfolio-mobile6.png'
import mobile7 from '../../assets/images/portfolio-mobile7.png'
import mobile8 from '../../assets/images/portfolio-mobile8.png'
import software1 from '../../assets/images/portfolio-software1.webp'
import software2 from '../../assets/images/portfolio-software2.webp'
import software3 from '../../assets/images/portfolio-software3.webp'
import software4 from '../../assets/images/portfolio-software4-1.png'
import software5 from '../../assets/images/portfolio-software5.webp'
import software6 from '../../assets/images/portfolio-software6.png'
import software7 from '../../assets/images/portfolio-website17.png'
import uiux1 from '../../assets/images/ui design.jpg'
import uiux2 from '../../assets/images/ux flow.jpg'
import uiux3 from '../../assets/images/prototype.png'
import uiux4 from '../../assets/images/mobile ui.jpg'
import uiux5 from '../../assets/images/design system.png'
import uiux6 from '../../assets/images/wireframe.png'
import dm1 from '../../assets/images/portfolio-dm1.webp'
import dm2 from '../../assets/images/portfolio-dm2.webp'
import dm3 from '../../assets/images/portfolio-dm3.webp'
import dm4 from '../../assets/images/portfolio-dm4.webp'
import dm5 from '../../assets/images/portfolio-dm5.webp'
import health from '../../assets/images/health.png'
import education from '../../assets/images/education.png'
import transport from '../../assets/images/transport.png'
import finance from '../../assets/images/finance.png'
import marketing from '../../assets/images/marketing.png'
import food from '../../assets/images/food.png'
import ecommerce from '../../assets/images/e-commerce.png'
import realestate from '../../assets/images/real estate.png'
import eventmanagement from '../../assets/images/events.png'
import logo1 from '../../assets/images/logo1.svg'
import logo2 from '../../assets/images/logo2.svg'
import logo3 from '../../assets/images/logo3.svg'
import logo4 from '../../assets/images/logo4.svg'
import logo5 from '../../assets/images/logo5.svg'
import logo6 from '../../assets/images/logo6.svg'
import logo7 from '../../assets/images/logo7.svg'
import logo8 from '../../assets/images/logo8.svg'
import logo9 from '../../assets/images/logo9.svg'
import logo10 from '../../assets/images/logo10.svg'
import logo11 from '../../assets/images/logo11.svg'
import logo12 from '../../assets/images/logo12.svg'
import logo13 from '../../assets/images/logo13.svg'
import logo14 from '../../assets/images/logo14.svg'
import logo15 from '../../assets/images/logo15.svg'
import logo16 from '../../assets/images/logo16.svg'
import expertiseMobile from '../../assets/images/logo1.svg'
import expertiseWeb from '../../assets/images/logo17.svg'
import expertiseReactNative from '../../assets/images/logo3.svg'
import expertiseWebsite from '../../assets/images/logo4.svg'
import expertiseERP from '../../assets/images/logo3.svg'
import expertiseAdmin from '../../assets/images/logo1.svg'
import expertiseUIUX from '../../assets/images/logo13.svg'
import expertiseBackend from '../../assets/images/logo16.svg'
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// useEffect(() => {
//   AOS.init({
//     duration: 800,
//     easing: 'ease-out-cubic',
//     once: true,
//   });
// }, []);
// Dummy project data - REPLACE WITH YOUR ACTUAL PROJECTS

// Add this useEffect to force mobile styles

const projectData = {
  website: [
    { title: "Sanjay Ghodawat University", image: website3, category: "website", url: "https://www.sanjayghodawat.co.in/" },
    { title: "GH Raisoni, Saikheda", image: website15, category: "website", url:"https://ghraisoni.com/"},
    { title: "JOY UNIVERSITY", image: website4, category: "website", url:"https://joyuniversity.edu.in/"},
    { title: "SANDIP UNIVERSITY", image: website5, category: "website", url:"https://www.sandipuniversity.edu.in/"  },
    { title: "RAYUDU GARI MILITARY HOTEL", image: website6, category: "website", url: "https://rgmhotel.com/" },
    { title: "ORION TECHNICAL COLLEGE", image: website7, category: "website", url:"https://orion.edu/"  },
    { title: "CYIENT", image: website8, category: "website", url:"https://www.cyient.com/geospatial/earth-observation" },
    { title: "CYCLOMEDIA", image: website9, category: "website", url:"https://www.cyclomedia.com/en/products/data-insights/geo-objects"},
    { title: "UNI HARBOUR", image: website10, category: "website", url:"https://www.uniharbour.com/"  },
    { title: "SRI JYOTHI POLYTECHNIC", image: website2, category: "website", url:"https://srijyothipolytechnic.com/" },
    { title: "ASIAN CROP CARE", image: website16, category: "website", url:"https://asiancropcare.co/"  },
    { title: "SRI ANJANEYA RESTAURANTS", image: website11, category: "website"},
    { title: "GSR FARMS AND FOODS", image: website12, category: "website"},
    { title: "SKII ARTS", image: website1, category: "website" },
    { title: "PENTIP", image: website13, category: "website" },
    { title: "SBID", image: website14, category: "website" }


  ],
  mobile: [
    { title: "Dhan Shakti", image: mobile1, category: "mobile" },
    { title: "High Ghar", image: mobile2, category: "mobile" },
    { title: "Oakya Ecom App", image: mobile3, category: "mobile" },
    { title: "Oakya Home Services", image: mobile4, category: "mobile" },
    { title: "Mech Guru", image: mobile5, category: "mobile" },
    { title: "School App", image: mobile6, category: "mobile" },
    { title: "Campus Connect", image: mobile7, category: "mobile" },
    { title: "Gait View", image: mobile8, category: "mobile" }



  ],
  software: [
    { title: "Indrashil University", image: software1, category: "software" },
    { title: "Dhan Shakti Admin", image: software2, category: "software" },
    { title: "School ERP", image: software6, category: "software" },
    { title: "Mech Guru", image: software7, category: "software" },
    { title: "Indrashil University (bipc)", image: software3, category: "software" },
    { title: "Sanjay Ghodawat University", image: software4, category: "software" },
    { title: "High Ghar", image: software5, category: "software" }
  ],
  uiux: [
     { title: "wire frame", image: uiux6, category: "uiux" },
    { title: "UI Design", image: uiux1, category: "uiux" },
    { title: "UX Flow", image: uiux2, category: "uiux" },
    { title: "Prototyping Tool", image: uiux3, category: "uiux" },
    { title: "Mobile UI", image: uiux4, category: "uiux" },
    { title: "Design System", image: uiux5, category: "uiux" }
  ],
  marketing: [
    { title: "SEO Optimization", image: dm1, category: "marketing" },
    { title: "Social Campaign", image: dm2, category: "marketing" },
    { title: "Email Marketing", image: dm3, category: "marketing" },
    { title: "PPC Advertising", image: dm4, category: "marketing" },
    { title: "Content Marketing", image: dm5, category: "marketing" }
  ]
};

const Portfolio = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeCategory, setActiveCategory] = useState('website');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [currentPage, setCurrentPage] = useState(0);
  const sectionsRef = useRef([]);
  const rocketRef = useRef(null);
  
  // LOGO CARDS REFS - FOR SIMULATE
  const logoCardRefs = useRef([]);
  // LOGO CARDS REFS - 9 CARDS FOR ADAPTED
  const adaptedLogoCardRefs = useRef(new Array(9).fill(null));

  const allClients = [
    client1, client2, client3, client4, client5, client6, client7, client8, client9,
    client10, client11, client12, client13, client14, client15, client16, client17, client18, client19, client20, client21
  ];
  const clientsPerPage = 9;
  const totalPages = Math.ceil(allClients.length / clientsPerPage);
  const currentClients = allClients.slice(currentPage * clientsPerPage, (currentPage + 1) * clientsPerPage);

  useEffect(() => {
    logoCardRefs.current = new Array(9).fill(null);
  }, [currentPage]);

//   useLayoutEffect(() => {
//   let ticking = false;
//   let prevScroll = window.scrollY;
//   const heroSection = document.querySelector('.hero');
//   const heroHeight = heroSection ? heroSection.offsetHeight : window.innerHeight;

//   const handleScroll = () => {
//     if (!ticking) {
//       requestAnimationFrame(() => {
//         const currentScroll = window.scrollY;
//         setScrollY(currentScroll);

//         // Check if the hero section is in view (scroll position is within hero section height)
//         if (currentScroll <= heroHeight && rocketRef.current) {
//           // Trigger animation on scroll down or up
//           if (currentScroll !== prevScroll) {
//             rocketRef.current.style.animation = 'none';
//             rocketRef.current.offsetHeight; // Trigger reflow
//             rocketRef.current.style.animation = 'rocketFlight 10s ease-in-out forwards';
//           }
//         }

//         prevScroll = currentScroll;
//         ticking = false;
//       });
//       ticking = true;
//     }
//   };

//   window.addEventListener('scroll', handleScroll);
//   window.addEventListener('resize', handleScroll);
//   handleScroll(); // Initial call to set up animation if already in view

//   return () => {
//     window.removeEventListener('scroll', handleScroll);
//     window.removeEventListener('resize', handleScroll);
//   };
// }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const els = entry.target.querySelectorAll(".animate-from-bottom");
          if (entry.isIntersecting) {
            els.forEach((el) => el.classList.add("reveal"));
          } else {
            els.forEach((el) => el.classList.remove("reveal"));
          }
        });
      },
      { threshold: 0.3 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });
    return () => observer.disconnect();
  }, []);

  // **3D MOUSEMOVE EFFECT - FOR SIMULATE**
  useEffect(() => {
    const handleMouseMove = (e) => {
      logoCardRefs.current.forEach((card) => {
        if (!card) return;
        
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const mouseX = (x - centerX) / centerX * 100;
        const mouseY = (y - centerY) / centerY * 100;
        
        card.style.setProperty('--mouse-x', `${mouseX.toFixed(2)}`);
        card.style.setProperty('--mouse-y', `${mouseY.toFixed(2)}`);
      });
    };

    const simulateLeft = document.querySelector('.simulate-left');
    if (simulateLeft) {
      simulateLeft.addEventListener('mousemove', handleMouseMove);
      
      simulateLeft.addEventListener('mouseleave', () => {
        logoCardRefs.current.forEach((card) => {
          if (!card) return;
          card.style.setProperty('--mouse-x', '0');
          card.style.setProperty('--mouse-y', '0');
        });
      });
    }

    return () => {
      if (simulateLeft) {
        simulateLeft.removeEventListener('mousemove', handleMouseMove);
        simulateLeft.removeEventListener('mouseleave', () => {});
      }
    };
  }, [currentPage]);

  // **3D MOUSEMOVE EFFECT - 9 CARDS FOR ADAPTED**
  useEffect(() => {
    const handleMouseMove = (e) => {
      adaptedLogoCardRefs.current.forEach((card) => {
        if (!card) return;
        
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const mouseX = (x - centerX) / centerX * 100;
        const mouseY = (y - centerY) / centerY * 100;
        
        card.style.setProperty('--mouse-x', `${mouseX.toFixed(2)}`);
        card.style.setProperty('--mouse-y', `${mouseY.toFixed(2)}`);
      });
    };

    const adaptedRight = document.querySelector('.adapted-right');
    if (adaptedRight) {
      adaptedRight.addEventListener('mousemove', handleMouseMove);
      
      adaptedRight.addEventListener('mouseleave', () => {
        adaptedLogoCardRefs.current.forEach((card) => {
          if (!card) return;
          card.style.setProperty('--mouse-x', '0');
          card.style.setProperty('--mouse-y', '0');
        });
      });
    }

    return () => {
      if (adaptedRight) {
        adaptedRight.removeEventListener('mousemove', handleMouseMove);
        adaptedRight.removeEventListener('mouseleave', () => {});
      }
    };
  }, []);

  const setSectionRef = useCallback(
    (index) => (el) => {
      sectionsRef.current[index] = el;
    },
    []
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission here (e.g., send to API)
  };

  const categories = [
    { id: 'website', label: 'Website' },
    { id: 'mobile', label: 'Mobile App' },
    { id: 'software', label: 'Software' },
    { id: 'uiux', label: 'UI/UX' },
    { id: 'marketing', label: 'Digital Marketing' }
  ];

  const currentProjects = projectData[activeCategory];

  const industries = [
    { name: "HEALTH", image: health, url:"https://demosite.oakyaitservices.com/oakyaprojects/healthcare/main/index.html" },
    { name: "EDUCATION", image: education, url:"https://schoolerp.oakyaitservices.in/" },
    { name: "TRANSPORT", image: transport, url:"https://demosite.oakyaitservices.com/oakyaprojects/travels/index.html"},
    { name: "FINANCE", image: finance },
    { name: "MARKETING", image: marketing },
    { name: "FOOD", image: food, url:"https://demosite.oakyaitservices.com/oakyaprojects/food/index.html" },
    { name: "E-COMMERCE", image:  ecommerce, url:"https://demosite.oakyaitservices.com/oakyaprojects/ecomm/index.html"},
    { name: "REAL-ESTATE", image: realestate, url:"https://siddhiganapathi.com/" },
    { name: "EVENT-MANAGEMENT", image: eventmanagement }
  ];

  return (
    <main role="main" className="portfolio-wrapper">
      


      {/* === OUR EXPERTISE SECTION - SIMPLE LAYOUT === */}
<section ref={setSectionRef(2)} className="section expertise-simple" id="expertise">
  <div className="expertise-simple-container">
    {/* <!-- HEADER --> */}
    <div className="expertise-header animate-from-bottom">
      <h2 className="expertise-title">Our Expertise</h2>
      <p className="expertise-subtitle animate-from-bottom delay-1">
        We craft digital solutions powered by innovation and driven by technology — delivering seamless experiences across web and mobile platforms.
      </p>
    </div>

    {/* <!-- TECHNOLOGIES SECTION --> */}
    <div className="technologies-section animate-from-bottom delay-2">
      <h3 className="technologies-title">Technologies We Master</h3>
      <p className="technologies-subtitle animate-from-bottom delay-3">We bring ideas to life using the latest, most reliable tech stack</p>
      <div className="technologies-grid">
        <div className="tech-card animate-from-bottom delay-4">
          <img src={expertiseWeb} alt="React JS" className="tech-icon" />
          <p className="tech-description">Fast, dynamic, and engaging user interfaces</p>
        </div>
        <div className="tech-card animate-from-bottom delay-5">
          <img src={expertiseBackend} alt=".NET" className="tech-icon" />
          <p className="tech-description">Secure and enterprise-ready backend systems</p>
        </div>
        <div className="tech-card animate-from-bottom delay-6">
          <img src={expertiseReactNative} alt="React Native" className="tech-icon" />
          <p className="tech-description">Cross-platform mobile apps with native performance</p>
        </div>
        <div className="tech-card animate-from-bottom delay-7">
          <img src={expertiseAdmin} alt="Node JS" className="tech-icon" />
          <p className="tech-description">Scalable and high-performing server-side solutions</p>
        </div>
      </div>
    </div>

    {/* <!-- SERVICES SECTION --> */}
    <div className="services-section animate-from-bottom delay-8">
      <h3 className="services-title">What We Build</h3>
      <p className="services-subtitle animate-from-bottom delay-9">By combining these technologies, we create powerful and elegant digital products</p>
      <div className="services-grid">
        <div className="service-card animate-from-bottom delay-10">
          <img src={expertiseMobile} alt="Mobile App Development" className="service-icon" />
          <h3 className="service-card-title">Mobile App Development</h3>
          <p className="service-card-tagline">Innovation in every tap</p>
          <p className="service-card-text">Sleek, high-performance apps that connect and convert</p>
        </div>
        <div className="service-card animate-from-bottom delay-11">
          <img src={expertiseWeb} alt="Web Development" className="service-icon" />
          <h3 className="service-card-title">Web Development</h3>
          <p className="service-card-tagline">Smart, scalable, and stunning</p>
          <p className="service-card-text">Scalable, dynamic, and user-centric web applications</p>
        </div>
        <div className="service-card animate-from-bottom delay-12">
          <img src={expertiseWebsite} alt="Robust Website Development" className="service-icon" />
          <h3 className="service-card-title">Robust Website Development</h3>
          <p className="service-card-tagline">Your digital identity, redefined</p>
          <p className="service-card-text">Reliable, secure, and visually stunning websites</p>
        </div>
      </div>
    </div>

    {/* <!-- STATS SECTION --> */}
    <div className="expertise-stats animate-from-bottom delay-13">
      <div className="stat-item animate-from-bottom delay-14">
        <span className="stat-number">500+</span>
        <span className="stat-label">Projects Delivered</span>
      </div>
      <div className="stat-item animate-from-bottom delay-15">
        <span className="stat-number">98%</span>
        <span className="stat-label">Client Satisfaction</span>
      </div>
      <div className="stat-item animate-from-bottom delay-16">
        <span className="stat-number">50+</span>
        <span className="stat-label">Expert Team</span>
      </div>
    </div>
  </div>
</section>

      
    </main>
  );
};

export default Portfolio;